import React, { useCallback } from 'react';
import get from 'lodash/get';
import lowerCase from 'lodash/lowerCase';
import sanitizeHtml from 'sanitize-html';
import { NorthEast } from '@yme/assets/icons';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { useTranslation } from '@yme/services/i18n';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getSearchResultLinkParams, getCategoryItemMessage } from './helpers';
import { LinkWrapperStyled, SearchItemStyled } from './styled';
export function SearchCategoryItem({ item: { name, count }, searchedValue, searchResultsPageUrl, isActive, handleClickLink, }) {
    const { t } = useTranslation();
    const parsedCategoryType = JSON.parse(t('globalSearch_primaryTypeCategory_map'));
    const itemMessage = getCategoryItemMessage(t('globalSearch_searchBarCategorySection_template'), searchedValue, get(parsedCategoryType, lowerCase(name), name), count);
    const onClickLink = useCallback(() => {
        handleClickLink(searchedValue);
    }, [handleClickLink, searchedValue]);
    return (React.createElement(SearchItemStyled, { isActive: isActive },
        React.createElement(LinkWrapperStyled, { onClick: onClickLink, to: {
                pathname: searchResultsPageUrl,
                search: getSearchResultLinkParams(searchedValue, name),
            } },
            React.createElement(SVGIcon, { type: NorthEast }),
            React.createElement(RegularTextLevel4, { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(itemMessage),
                } }))));
}
